import React, {FC} from 'react'
import {Spinner} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import {MessageSentCardProps} from './types'

// Helper function to format numbers with thousand separators
const formatNumber = (num: number): string => num.toLocaleString()

const MessageSentCard: FC<MessageSentCardProps> = React.memo(
  ({totalSms, totalSmsParts, totalMms, totalMmsParts, providers, loading}) => (
    <div className='metric-group-card card h-100'>
      <div className='card-header border-0 pt-5 pb-0'>
        <div className='card-title'>
          <KTSVG
            path='/media/icons/duotune/communication/com002.svg'
            className='svg-icon-2 svg-icon-primary me-2'
          />
          <h3 className='fw-bold fs-5 mb-0'>Message Sent</h3>
        </div>
      </div>
      <div className='card-body pt-4'>
        {/* Total Summary */}
        <div className='d-flex gap-4 mb-4 pb-4 border-bottom'>
          <div className='flex-fill text-center'>
            <div className='fs-2x fw-bold text-primary'>
              {loading ? <Spinner size='sm' animation='border' /> : formatNumber(totalSms)}
            </div>
            <div className='fs-8 text-muted fw-semibold'>SMS Sent</div>
            <div className='fs-9 text-gray-500'>
              {loading ? '...' : `${formatNumber(totalSmsParts)} parts`}
            </div>
          </div>
          <div className='flex-fill text-center'>
            <div className='fs-2x fw-bold text-success'>
              {loading ? <Spinner size='sm' animation='border' /> : formatNumber(totalMms)}
            </div>
            <div className='fs-8 text-muted fw-semibold'>MMS Sent</div>
            <div className='fs-9 text-gray-500'>
              {loading ? '...' : `${formatNumber(totalMmsParts)} parts`}
            </div>
          </div>
        </div>

        {/* Per Provider Breakdown */}
        <div className='provider-breakdown'>
          <div className='fs-8 text-muted fw-bold text-uppercase mb-3'>Per Provider</div>
          <div className='table-responsive'>
            <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-2 mb-0'>
              <thead>
                <tr className='fs-9 fw-bold text-muted'>
                  <th>Provider</th>
                  <th className='text-end'>Sent</th>
                  <th className='text-end'>Parts</th>
                </tr>
              </thead>
              <tbody>
                {providers.map((p) => (
                  <tr key={p.provider}>
                    <td className='fs-7 fw-semibold text-gray-700'>{p.provider}</td>
                    <td className='text-end fs-7 fw-bold'>
                      {p.loading ? <Spinner size='sm' animation='border' /> : formatNumber(p.sent)}
                    </td>
                    <td className='text-end fs-7 text-gray-600'>
                      {p.loading ? '...' : formatNumber(p.parts)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
)

MessageSentCard.displayName = 'MessageSentCard'

export default MessageSentCard
